import { styled, Box } from '@mui/material';

export const StyledEmptyListMessageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 20,
  [theme.breakpoints.down('md')]: {
    padding: '0 12px',
  },
}));
